import React from 'react'

export const DownloadIcon2 = (): JSX.Element => (
  <svg
    width="14"
    height="14"
    fill="currentColor"
    viewBox="0 0 512 512"
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
  >
    <path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24z" />
    <path d="M464 288h-52.5l-44.5 77.8c-12.2 21.4-35 34.2-59.8 34.2H174.3c-24.8 0-47.6-12.8-59.8-34.2L70.1 288H48c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48zm-16 144c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16zm48 0c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16 16 7.2 16 16z" />
  </svg>
)
